<template>
    <div
        :class="
            options.namespace +
            '-base-container scroller-at-' +
            options.scroller_position
        "
    >
        <div class="zoom_img main_zoom_area">
            <div class="fav_cart favriout">
                <a
                    href="#"
                    data-toggle="modal"
                    v-if="!isAuthenticatedClient"
                    v-tooltip="'Add to favorite!'"
                    :data-path="$route.path"
                    data-target="#login"
                >
                    <img src="/maincss/images/favriout_produt.svg" alt=" " />
                </a>
                <a
                    href="javascript:void(0)"
                    v-else-if="!is_favorite_product"
                    v-tooltip="'Add to favorite!'"
                    @click="!isBusy ? addToFavorite(product) : ''"
                >
                    <img src="/maincss/images/favriout_produt.svg" alt=" " />
                </a>
                <a
                    v-else-if="is_favorite_product"
                    v-tooltip="'Favorite product!'"
                    class="favorite_button"
                    @click="!isBusy ? removeFromFavorite(favorite_product) : ''"
                    ><img src="/maincss/images/heart_red.svg" alt=" "
                /></a>
            </div>
            <div class="priview_icon" v-show="thumbs.length > 1">
                <img
                    @click="moveImage('backward')"
                    src="/maincss/images/rt.png"
                />
            </div>
            <img
                v-if="!isImageLoaded && fileType == 'image'"
                src="https://john015.github.io/vue-load-image/static/image-loader.gif"
                alt=""
            />
            <img
                v-show="fileType == 'image' && isImageLoaded"
                :src="previewImg.url"
                :id="previewImg.id"
                :data-zoom="previewLargeImg.url"
                class="responsive-image preview-box remove_aspect_ratio_imp"
                draggable="false"
                @load="loadImageEvent"
            />
            <video
                v-show="
                    fileType == 'video' && !isEmbeddableVideoUrl(previewImg.url)
                "
                width="400"
                height="100%"
                controls="controls"
                :src="
                    previewImg.url
                        ? previewImg.url + '#t=0.1'
                        : '/maincss/images/featured_product_1.png'
                "
                class="responsive-image preview-box"
            ></video>
            <iframe
                v-show="
                    fileType == 'video' && isEmbeddableVideoUrl(previewImg.url)
                "
                width="400"
                height="100%"
                :src="getEmbedUrl(previewImg.url)"
                frameborder="0"
                allow="autoplay; fullscreen; picture-in-picture"
                allowfullscreen
                class="responsive-image preview-box"
            ></iframe>
            <div class="right_icon" v-show="thumbs.length > 1">
                <img
                    @click="moveImage('forward')"
                    src="/maincss/images/lt.png"
                />
            </div>
        </div>
        <div class="thumb-img_wdt_hgt">
            <div class="thumb-list">
                <img
                    style="display: none"
                    @click="moveThumbs('backward')"
                    :src="scroller_icon_first"
                    class="zoomer-control responsive-image arrow_icon_lft _rgt"
                    alt="move thumb icon"
                />
                <div class="zoom_thumb_ext">
                    <template v-for="(thumb, key) in thumbs">
                        <div
                            v-if="thumb.type == 'image'"
                            :key="'thumb-img-' + key"
                            @click="chooseThumb(thumb, $event)"
                            class="left_zoomer_images"
                            :class="[
                                {
                                    'choosed-thumb':
                                        thumb.id === choosedThumb.id
                                },
                                thumbCapClasses(thumb)
                            ]"
                            v-bind:style="{
                                boxShadow:
                                    thumb.id === choosedThumb.id
                                        ? '0px 0px 0px 2px ' +
                                          options.choosed_thumb_border_color
                                        : ''
                            }"
                        >
                            <img
                                draggable="false"
                                v-show="key < options.scroll_items"
                                :key="'img-' + thumb.id + '-' + key"
                                :src="
                                    thumb.type != 'image'
                                        ? 'https://img.youtube.com/vi/' +
                                          thumb.thumb_url +
                                          '/default.jpg'
                                        : thumb.thumb_url
                                        ? thumb.thumb_url
                                        : thumb.url
                                "
                                class="responsive-image"
                            />
                        </div>

                        <div
                            v-else-if="!isEmbeddableVideoUrl(thumb.url)"
                            :key="'thumb-video-' + key"
                            @click="chooseThumb(thumb, $event)"
                            class="left_zoomer_images"
                            :class="{
                                'choosed-thumb': thumb.id === choosedThumb.id
                            }"
                            v-bind:style="{
                                boxShadow:
                                    thumb.id === choosedThumb.id
                                        ? '0px 0px 0px 2px ' +
                                          options.choosed_thumb_border_color
                                        : ''
                            }"
                        >
                            <video
                                draggable="false"
                                v-show="key < options.scroll_items"
                                :key="'video-' + thumb.id + '-' + key"
                                :src="
                                    thumb.url + '#t=0.1' ||
                                    '/maincss/images/featured_product_1.png'
                                "
                                class="responsive-image"
                            ></video>
                        </div>
                        <div
                            v-else
                            draggable="false"
                            v-show="key < options.scroll_items"
                            :key="'embed-' + thumb.id + '-' + key"
                            @click="chooseThumb(thumb, $event)"
                            class="responsive-image embed-video-thumb"
                            v-bind:style="{
                                boxShadow:
                                    thumb.id === choosedThumb.id
                                        ? '0px 0px 0px 2px ' +
                                          options.choosed_thumb_border_color
                                        : ''
                            }"
                            :class="{
                                'choosed-thumb': thumb.id === choosedThumb.id
                            }"
                        >
                            <img
                                :src="getVideoThumbnail(thumb.url)"
                                alt="Video thumbnail"
                                style="
                                    width: 100%;
                                    height: 100%;
                                    object-fit: cover;
                                "
                            />
                        </div>
                    </template>
                    <img
                        style="display: none"
                        @click="moveThumbs('forward')"
                        :src="scroller_icon_second"
                        class="zoomer-control responsive-image arrow_icon_lft _rgt"
                        alt="move thumb icon"
                    />
                </div>
            </div>
        </div>
        <div :id="pane_container_id" class="pane-container"></div>
        <div class="preloader" v-show="isBusy">
            <div class="preloader-body">
                <svg width="40" height="40" viewBox="0 0 40 40">
                    <polygon
                        class="rect"
                        points="0 0 0 40 40 40 40 0"
                    ></polygon>
                </svg>
            </div>
        </div>
    </div>
</template>

<script>
import { mapGetters } from "vuex";
import ApiService from "@/common/api.service";
import {
    shouldApplyCapCategoryClass as shouldApplyCapCategoryClassService,
    shouldApplyCapNonHatClass as shouldApplyCapNonHatClassService
} from "@/common/capCategoryImage.service";

import Drift from "../assets/drift-zoom/src/js/Drift.js";
import FillDown from "../assets/svg-icons/arrow-down-s-fill.svg";
import LineDown from "../assets/svg-icons/arrow-down-s-line.svg";
import FillLeft from "../assets/svg-icons/arrow-left-s-fill.svg";
import LineLeft from "../assets/svg-icons/arrow-left-s-line.svg";
import FillRight from "../assets/svg-icons/arrow-right-s-fill.svg";
import LineRight from "../assets/svg-icons/arrow-right-s-line.svg";
import FillUp from "../assets/svg-icons/arrow-up-s-fill.svg";
import LineUp from "../assets/svg-icons/arrow-up-s-line.svg";
const actionName = (s) =>
    "scrollerAt" + (s.substr(0, 1).toUpperCase() + s.substr(1).toLowerCase());

const getCaculatedPanePosition = (paneStyle = "pane", rect, PanePosition) => {
    let caculatedPosition = "";
    if (PanePosition === "left") {
        caculatedPosition =
            "width:" +
            rect.width +
            "px;height:" +
            rect.height +
            "px;left:" +
            (paneStyle === "container"
                ? 0
                : 0 - rect.width - window.scrollX - 5) +
            "px;";
    } else if (PanePosition === "right") {
        caculatedPosition =
            "width:" +
            rect.width +
            "px;height:" +
            rect.height +
            "px;left:" +
            (paneStyle === "container" ? 0 : rect.width + window.scrollX + 5) +
            "px;";
    }

    return caculatedPosition;
};

export default {
    name: "ProductZoomer",
    props: {
        product: {
            type: Object,
            default: function () {
                return {};
            }
        },
        baseZoomerOptions: {
            type: Object,
            default: function () {
                return {};
            }
        },
        baseImages: {
            type: Object,
            required: true,
            default: function () {
                return {};
            }
        }
    },
    data() {
        return {
            is_favorite_product: false,
            favorite_product: [],
            isBusy: false,
            previewImg: {},
            fileType: "image",
            previewLargeImg: {},
            thumbs: [],
            normal_size: [],
            large_size: [],
            choosedThumb: {},
            drift: null,
            options: {
                zoomFactor: 4,
                pane: "container",
                hoverDelay: 300,
                namespace: "container-zoomer",
                move_by_click: true,
                scroll_items: 4,
                choosed_thumb_border_color: "#ff3d00",
                scroller_button_style: "line",
                scroller_position: "left",
                zoomer_pane_position: "right"
            },
            isImageLoaded: true
        };
    },
    computed: {
        ...mapGetters(["isAuthenticatedClient", "currentUserClient"]),
        base_container_div: function () {
            return document.querySelector(
                "." + this.options.namespace + "-base-container"
            );
        },
        pane_container_id: function () {
            return this.options.namespace + "-pane-container";
        },
        preview_img: function () {
            return (
                "." + this.options.namespace + "-base-container .preview-box"
            );
        },
        scroller_icon_first: function () {
            if (["top", "bottom"].includes(this.options.scroller_position)) {
                if (this.options.scroller_button_style === "line") {
                    return LineLeft;
                } else {
                    return FillLeft;
                }
            } else if (
                ["left", "right"].includes(this.options.scroller_position)
            ) {
                if (this.options.scroller_button_style === "line") {
                    return LineUp;
                } else {
                    return FillUp;
                }
            }
            return true;
        },
        scroller_icon_second: function () {
            if (["top", "bottom"].includes(this.options.scroller_position)) {
                if (this.options.scroller_button_style === "line") {
                    return LineRight;
                } else {
                    return FillRight;
                }
            } else if (
                ["left", "right"].includes(this.options.scroller_position)
            ) {
                if (this.options.scroller_button_style === "line") {
                    return LineDown;
                } else {
                    return FillDown;
                }
            }
            return true;
        }
    },
    updated() {
        this.large_size = Object.assign([], this.normal_size);
    },
    mounted() {
        // this.loadProductZoomer();
    },
    watch: {
        choosedThumb: function (thumb) {
            if (!thumb) {
                return;
            }
            let matchNormalImg = this.normal_size.find((img) => {
                return img.id === thumb.id;
            });
            let matchLargeImg = this.large_size.find((img) => {
                return img.id === thumb.id;
            });
            this.previewLargeImg = Object.assign({}, matchLargeImg);
            this.previewImg = Object.assign({}, matchNormalImg);
            this.fileType = thumb.type;
            this.$emit("preview-image-changed", this.previewImg.url || "");
            if (this.drift !== null && matchLargeImg) {
                this.drift.setZoomImageURL(matchLargeImg.url);
            }
        },
        baseImages: function () {
            this.loadProductZoomer();
        }
    },
    created() {},
    methods: {
        loadProductZoomer() {
            var _this = this;

            if (
                !["left", "right", "top", "bottom"].includes(
                    this.options.scroller_position
                )
            ) {
                throw "scroller_position is invalid";
            }
            if (
                !["fill", "line"].includes(this.options.scroller_button_style)
            ) {
                throw "scroller_button_style is invalid";
            }
            if (
                !["left", "right"].includes(this.options.zoomer_pane_position)
            ) {
                throw "zoomer_pane_position is invalid";
            }

            this.$nextTick(() => {
                this[actionName(this.options.scroller_position)]();
                this.options.injectBaseStyles = true;
                if (this.options.pane === "container-round") {
                    this.options.inlinePane = true;
                } else {
                    this.options.inlinePane = false;
                    this.options.paneContainer = document.getElementById(
                        this.pane_container_id
                    );
                    let rect = document
                        .querySelector(
                            "." + this.options.namespace + "-base-container"
                        )
                        .getBoundingClientRect();
                    document
                        .getElementById(this.pane_container_id)
                        .setAttribute(
                            "style",
                            getCaculatedPanePosition(
                                this.options.pane,
                                rect,
                                this.options.zoomer_pane_position
                            )
                        );
                }

                if (screen && screen.width > 1024) {
                    this.drift = new Drift(
                        document.querySelector(this.preview_img),
                        this.options
                    );
                }
            });

            setTimeout(() => {
                _this.getFavoriteProduct();
                /* eslint-disable */
                if (Object.keys(this.baseImages).length > 0) {
                    for (const key in this.baseImages) {
                        if (this.baseImages.hasOwnProperty(key)) {
                            this[key] = this.baseImages[key];
                        }
                    }
                }
                if (this.normal_size.length === 0) {
                    //   this.$router.go();
                    throw "Product Zoomer Need Normal Size Image At Least!!!";
                }
                if (this.thumbs.length === 0) {
                    this.thumbs = Object.assign([], this.thumb);
                } else {
                    this.choosedThumb = this.thumbs[0];
                }

                if (this.large_size.length === 0) {
                    this.large_size = Object.assign([], this.normal_size);
                }
                if (Object.keys(this.baseZoomerOptions).length > 0) {
                    for (const key in this.baseZoomerOptions) {
                        if (this.baseZoomerOptions.hasOwnProperty(key)) {
                            const element = this.baseZoomerOptions[key];
                            this.options[key] = element;
                        }
                    }
                }
                /* eslint-enable */
                if (
                    this.options.pane === "container-round" ||
                    this.options.pane === "container"
                ) {
                    this.options.hoverBoundingBox = false;
                } else {
                    this.options.hoverBoundingBox = true;
                }
            }, 1000);
        },
        removeFromFavorite(favorite_product) {
            var _this = this;
            // setTimeout(() => {
            if (favorite_product && favorite_product.id) {
                new Promise(() => {
                    _this.isBusy = true;
                    ApiService.post("/delete/favorite-product", {
                        ids: favorite_product.id
                    })
                        .then(({ data }) => {
                            // console.log(data);
                            if (data.success) {
                                _this.$toast.success(
                                    "Product removed from your favorite list.",
                                    {
                                        position: "top-right",
                                        queue: true
                                    }
                                );
                                _this.is_favorite_product = false;
                                _this.isBusy = false;
                                _this.getFavoriteProduct(_this.product);
                            }
                        })
                        .catch(({ _response }) => {});
                });
            }
            // }, 1000);
        },
        getFavoriteProduct() {
            let product = this.product;
            var _this = this;
            if (_this.currentUserClient.id && product.id) {
                new Promise(() => {
                    _this.isBusy = false;
                    ApiService.get("/favorite-product/" + product.id)
                        .then(({ data }) => {
                            _this.favorite_product = data.favorite_product;

                            _this.is_favorite_product = data.favorite_product.id
                                ? true
                                : false;
                            _this.isBusy = false;
                        })
                        .catch(({ _response }) => {});
                });
            }
        },
        addToFavorite(product) {
            var _this = this;
            // setTimeout(() => {
            if (_this.currentUserClient.id) {
                new Promise(() => {
                    // _this.isBusy = true;
                    let post_data = { product_id: product.id };
                    ApiService.post("/favorite-product", post_data)
                        .then(({ data }) => {
                            if (data.success) {
                                _this.$toast.success(data.message, {
                                    position: "top-right",
                                    queue: true
                                });
                            }
                            _this.is_favorite_product = true;
                            _this.getFavoriteProduct(_this.product);
                            // _this.isBusy = false;
                        })
                        .catch(({ _response }) => {});
                });
            }
            // }, 1000);
        },
        moveThumbs(direction) {
            let len = this.thumbs.length;
            if (direction === "backward") {
                const moveThumb = this.thumbs.splice(len - 1, 1);
                this.thumbs = [moveThumb[0], ...this.thumbs];
            } else {
                const moveThumb = this.thumbs.splice(0, 1);
                this.thumbs = [...this.thumbs, moveThumb[0]];
            }
        },
        moveImage(direction) {
            let indexofThumb = this.thumbs.indexOf(this.choosedThumb);
            if (direction == "forward") {
                // this.moveThumbs("forward");
                // Clamp to the last index so a single-image gallery (or the last
                // thumb) does not resolve to thumbs[length] === undefined.
                let thumbindex =
                    indexofThumb < this.thumbs.length - 1
                        ? indexofThumb + 1
                        : indexofThumb;
                this.choosedThumb =
                    this.thumbs[thumbindex] || this.choosedThumb;
                this.moveThumbs("forward");
            } else {
                // this.moveThumbs("backward");
                let thumbindex = indexofThumb > 1 ? indexofThumb - 1 : 0;
                this.choosedThumb = this.thumbs[thumbindex];
                // console.log();
                this.moveThumbs("backward");
            }
        },
        chooseThumb(thumb, event) {
            this.isImageLoaded = false;
            let eventType = event.type;
            if (eventType === "mouseover") {
                // if (this.options.move_by_click !== true) {
                this.choosedThumb = thumb;
                // }
            } else {
                this.choosedThumb = thumb;
            }
        },
        resolveThumbImageUrl(thumb) {
            return thumb && thumb.thumb_url ? thumb.thumb_url : thumb.url;
        },
        thumbCapClasses(thumb) {
            const categoryId =
                this.product && this.product.category_id
                    ? this.product.category_id
                    : null;
            const imageUrl = this.resolveThumbImageUrl(thumb);
            return {
                cap_category_images: shouldApplyCapCategoryClassService(
                    categoryId,
                    imageUrl
                ),
                "non-hat": shouldApplyCapNonHatClassService(
                    categoryId,
                    imageUrl
                )
            };
        },
        isVimeoUrl(url) {
            if (!url) return false;
            // Check if URL is a Vimeo URL
            const vimeoRegex =
                /(?:https?:\/\/)?(?:www\.)?(?:player\.)?vimeo\.com\/(?:channels\/(?:\w+\/)?|groups\/(?:[^/]*)\/videos\/|video\/|)(\d+)(?:|\/\?)/;
            return vimeoRegex.test(url);
        },
        isYouTubeUrl(url) {
            if (!url) return false;
            // Check if URL is a YouTube URL
            // Supports: youtube.com/watch?v=, youtu.be/, youtube.com/embed/, youtube.com/v/
            const youtubeRegex =
                /(?:https?:\/\/)?(?:www\.)?(?:youtube\.com\/(?:watch\?v=|embed\/|v\/)|youtu\.be\/)([a-zA-Z0-9_-]{11})(?:[?&].*)?/;
            return youtubeRegex.test(url);
        },
        isEmbeddableVideoUrl(url) {
            // Check if URL is Vimeo or YouTube (embeddable video platforms)
            return this.isVimeoUrl(url) || this.isYouTubeUrl(url);
        },
        getVimeoEmbedUrl(url) {
            if (!url) return "";
            // Extract Vimeo video ID and convert to embed URL
            const vimeoRegex =
                /(?:https?:\/\/)?(?:www\.)?(?:player\.)?vimeo\.com\/(?:channels\/(?:\w+\/)?|groups\/(?:[^/]*)\/videos\/|video\/|)(\d+)(?:|\/\?)/;
            const match = url.match(vimeoRegex);
            if (match && match[1]) {
                return `https://player.vimeo.com/video/${match[1]}?title=0&byline=0&portrait=0`;
            }
            return url;
        },
        getYouTubeEmbedUrl(url) {
            if (!url) return "";
            // Extract YouTube video ID and convert to embed URL
            // Supports: youtube.com/watch?v=, youtu.be/, youtube.com/embed/, youtube.com/v/
            const youtubeRegex =
                /(?:https?:\/\/)?(?:www\.)?(?:youtube\.com\/(?:watch\?v=|embed\/|v\/)|youtu\.be\/)([a-zA-Z0-9_-]{11})(?:[?&].*)?/;
            const match = url.match(youtubeRegex);
            if (match && match[1]) {
                return `https://www.youtube.com/embed/${match[1]}`;
            }
            return url;
        },
        getEmbedUrl(url) {
            // Get embed URL for either Vimeo or YouTube
            if (this.isVimeoUrl(url)) {
                return this.getVimeoEmbedUrl(url);
            } else if (this.isYouTubeUrl(url)) {
                return this.getYouTubeEmbedUrl(url);
            }
            return url;
        },
        getVimeoThumbnail(url) {
            if (!url) return "/maincss/images/featured_product_1.png";
            // Extract Vimeo video ID and get thumbnail
            const vimeoRegex =
                /(?:https?:\/\/)?(?:www\.)?(?:player\.)?vimeo\.com\/(?:channels\/(?:\w+\/)?|groups\/(?:[^/]*)\/videos\/|video\/|)(\d+)(?:|\/\?)/;
            const match = url.match(vimeoRegex);
            if (match && match[1]) {
                // Use vumbnail.com service for Vimeo thumbnails (free service)
                // Fallback to placeholder if service is unavailable
                return `https://vumbnail.com/${match[1]}.jpg`;
            }
            return "/maincss/images/featured_product_1.png";
        },
        getYouTubeThumbnail(url) {
            if (!url) return "/maincss/images/featured_product_1.png";
            // Extract YouTube video ID and get thumbnail
            const youtubeRegex =
                /(?:https?:\/\/)?(?:www\.)?(?:youtube\.com\/(?:watch\?v=|embed\/|v\/)|youtu\.be\/)([a-zA-Z0-9_-]{11})(?:[?&].*)?/;
            const match = url.match(youtubeRegex);
            if (match && match[1]) {
                // YouTube provides thumbnails at: https://img.youtube.com/vi/VIDEO_ID/default.jpg
                // Options: default.jpg, mqdefault.jpg, hqdefault.jpg, sddefault.jpg, maxresdefault.jpg
                return `https://img.youtube.com/vi/${match[1]}/mqdefault.jpg`;
            }
            return "/maincss/images/featured_product_1.png";
        },
        getVideoThumbnail(url) {
            // Get thumbnail for either Vimeo or YouTube
            if (this.isVimeoUrl(url)) {
                return this.getVimeoThumbnail(url);
            } else if (this.isYouTubeUrl(url)) {
                return this.getYouTubeThumbnail(url);
            }
            return "/maincss/images/featured_product_1.png";
        },
        loadImageEvent() {
            this.isImageLoaded = true;
        },
        scrollerAtBottom() {
            let scrollerItemsCount =
                parseInt(this.baseZoomerOptions.scroll_items) + 2;
            let previewImg = document.querySelector(
                "." +
                    this.options.namespace +
                    "-base-container " +
                    ".preview-box"
            );
            let thumbList = document.querySelector(
                "." +
                    this.options.namespace +
                    "-base-container " +
                    ".thumb-list"
            );
            let thumbListHeight =
                (thumbList.children[1].naturalHeight *
                    (previewImg.naturalWidth /
                        thumbList.children[1].naturalWidth)) /
                (scrollerItemsCount - 1);
            document
                .querySelector("." + this.options.namespace + "-base-container")
                .setAttribute(
                    "style",
                    "height:" +
                        (previewImg.naturalHeight + thumbListHeight + 2) +
                        "px;width:" +
                        previewImg.naturalHeight +
                        "px;position:relative"
                );
            document
                .querySelector(
                    "." +
                        this.options.namespace +
                        "-base-container " +
                        ".thumb-list"
                )
                .setAttribute(
                    "style",
                    "width:" +
                        previewImg.naturalWidth +
                        "px;height:" +
                        thumbListHeight +
                        "px;grid-template-columns:calc(100%/" +
                        scrollerItemsCount +
                        "/2) repeat(" +
                        (scrollerItemsCount - 2) +
                        ", auto) calc(100%/" +
                        scrollerItemsCount +
                        "/2);visibility:visible;"
                );
        },
        scrollerAtTop() {
            let scrollerItemsCount =
                parseInt(this.baseZoomerOptions.scroll_items) + 2;
            let previewImg = document.querySelector(
                "." +
                    this.options.namespace +
                    "-base-container " +
                    ".preview-box"
            );
            let thumbList = document.querySelector(
                "." +
                    this.options.namespace +
                    "-base-container " +
                    ".thumb-list"
            );
            let thumbListHeight =
                (thumbList.children[1].naturalHeight *
                    (previewImg.naturalWidth /
                        thumbList.children[1].naturalWidth)) /
                (scrollerItemsCount - 1);
            document
                .querySelector("." + this.options.namespace + "-base-container")
                .setAttribute(
                    "style",
                    "height:" +
                        (previewImg.naturalHeight + thumbListHeight + 2) + // 2px for grid gap
                        "px;width:" +
                        previewImg.naturalHeight +
                        "px;position:relative"
                );
            document
                .querySelector(
                    "." +
                        this.options.namespace +
                        "-base-container " +
                        ".thumb-list"
                )
                .setAttribute(
                    "style",
                    "width:" +
                        previewImg.naturalWidth +
                        "px;height:" +
                        thumbListHeight +
                        "px;grid-template-columns:calc(100%/" +
                        scrollerItemsCount +
                        "/2) repeat(" +
                        (scrollerItemsCount - 2) +
                        ", auto) calc(100%/" +
                        scrollerItemsCount +
                        "/2);visibility:visible;"
                );
        },
        scrollerAtRight() {
            let scrollerItemsCount =
                parseInt(this.baseZoomerOptions.scroll_items) + 2;
            let previewImg = document.querySelector(
                "." +
                    this.options.namespace +
                    "-base-container " +
                    ".preview-box"
            );
            let thumbList = document.querySelector(
                "." +
                    this.options.namespace +
                    "-base-container " +
                    ".thumb-list"
            );
            let thumbListWidth =
                (thumbList.children[1].naturalWidth *
                    (previewImg.naturalHeight /
                        thumbList.children[1].naturalHeight)) /
                (scrollerItemsCount - 1);
            document
                .querySelector("." + this.options.namespace + "-base-container")
                .setAttribute(
                    "style",
                    "width:" +
                        (previewImg.naturalWidth + thumbListWidth + 2) +
                        "px;position:relative"
                );
            document
                .querySelector(
                    "." +
                        this.options.namespace +
                        "-base-container " +
                        ".thumb-list"
                )
                .setAttribute(
                    "style",
                    "height:" +
                        previewImg.naturalHeight +
                        "px;width:" +
                        thumbListWidth +
                        "px;grid-template-rows:calc(100%/" +
                        scrollerItemsCount +
                        "/2) repeat(" +
                        (scrollerItemsCount - 2) +
                        ", auto) calc(100%/" +
                        scrollerItemsCount +
                        "/2);visibility:visible;"
                );
        },
        scrollerAtLeft() {
            let scrollerItemsCount =
                parseInt(this.baseZoomerOptions.scroll_items) + 2;
            let previewImg = document.querySelector(
                "." +
                    this.options.namespace +
                    "-base-container " +
                    ".preview-box"
            );
            let thumbList = document.querySelector(
                "." +
                    this.options.namespace +
                    "-base-container " +
                    ".thumb-list"
            );
            let thumbListWidth =
                (thumbList.children[1].naturalWidth *
                    (previewImg.naturalHeight /
                        thumbList.children[1].naturalHeight)) /
                (scrollerItemsCount - 1);
            document
                .querySelector("." + this.options.namespace + "-base-container")
                .setAttribute(
                    "style",
                    "width:" +
                        (previewImg.naturalWidth + thumbListWidth + 2) + // 2px for grid gap
                        "px;position:relative"
                );
            document
                .querySelector(
                    "." +
                        this.options.namespace +
                        "-base-container " +
                        ".thumb-list"
                )
                .setAttribute(
                    "style",
                    "height:" +
                        previewImg.naturalHeight +
                        "px;width:" +
                        thumbListWidth +
                        "px;grid-template-rows:calc(100%/" +
                        scrollerItemsCount +
                        "/2) repeat(" +
                        (scrollerItemsCount - 2) +
                        ", auto) calc(100%/" +
                        scrollerItemsCount +
                        "/2);visibility:visible;"
                );
        }
    }
};
</script>
<style>
@import "../assets/drift-zoom/src/css/drift-basic.css";
</style>

<style scoped>
.scroller-at-top {
    display: grid;
    grid-gap: 2px;
    grid-template-columns: 1fr;
    align-items: center;
}

.scroller-at-top .preview-box {
    grid-column: 1 / 2;
    grid-row: 2 / 3;
}

.scroller-at-top .thumb-list {
    display: grid;
    align-items: center;
    grid-column-gap: 0.2em;
    grid-column: 1 / 2;
    grid-row: 1 / 2;
    visibility: hidden;
}
.scroller-at-bottom {
    display: grid;
    grid-gap: 2px;
    grid-template-columns: 1fr;
    align-items: center;
}

.scroller-at-bottom .preview-box {
    grid-column: 1 / 2;
    grid-row: 1 / 2;
}

.scroller-at-bottom .thumb-list {
    display: grid;
    align-items: center;
    grid-column-gap: 0.2em;
    grid-column: 1 / 2;
    grid-row: 2 / 3;
    visibility: hidden;
}

.scroller-at-left {
    display: grid;
    grid-gap: 2px;
    grid-template-columns: 1fr;
}

.scroller-at-left .preview-box {
    grid-column: 2 / 3;
    grid-row: 1 / 2;
}

.scroller-at-left .thumb-list {
    display: grid;
    grid-row-gap: unset !important;
    grid-column: 1 / 2;
    grid-row: 1 / 2;
    visibility: hidden;
    justify-items: center;
}

.scroller-at-right {
    display: grid;
    grid-gap: 2px;
    grid-template-columns: 1fr;
}

.scroller-at-right .preview-box {
    grid-column: 1 / 2;
    grid-row: 1 / 2;
}

.scroller-at-right .thumb-list {
    display: grid;
    grid-row-gap: 1.2em;
    grid-column: 2 / 3;
    grid-row: 1 / 2;
    visibility: hidden;
    justify-items: center;
    grid-template-rows: unset !important;
}

.scroller-at-right .thumb-list .responsive-image,
.scroller-at-left .thumb-list .responsive-image {
    width: auto;
    height: 100%;
}

.scroller-at-top .thumb-list .responsive-image,
.scroller-at-bottom .thumb-list .responsive-image {
    height: auto;
    width: 100%;
}

.zoomer-control {
    cursor: pointer;
}
.choosed-thumb {
    border-radius: 0px;
}
.pane-container {
    display: none;
    position: absolute;
    z-index: 10000;
    pointer-events: none;
}
.zoomer-base-container {
    width: 100% !important;
    display: flex;
    flex-direction: row-reverse;
}
.preview-box {
    width: 85%;
}
.thumb-list {
    width: 103px !important;
    grid-template-rows: none !important;
    grid-row-gap: 1rem !important;
}
.thumb-list img {
    width: 100% !important;
    border: none;
}
.thumb-list .left_zoomer_images {
    border: 2px solid #cecece;
    height: 103px;
}
.pane-container {
    right: -65% !important;
    left: auto !important;
    width: 65% !important;
    height: 65% !important;
    z-index: 111 !important;
    background-color: #fff !important;
}
.zoomer-base-container video {
    width: 100%;
}
.zoomer-base-container iframe {
    width: 100%;
    height: 100%;
    min-height: 400px;
}
.zoom_img {
    width: 100%;
    margin-left: 61px;
    border: 1px solid #e9e9e9;
    padding: 60px;
    height: 678px;
    display: flex;
    justify-content: center;
    align-items: center;
}
.arrow_icon_lft._rgt {
    border: unset !important;
    width: 40% !important;
    margin: 0 auto;
    display: flex;
}
.fav_cart {
    position: absolute;
    top: 10px;
    right: 10px;
}
.choosed-thumb {
    border: 2px solid #f2790c !important;
    box-shadow: unset !important;
}
.zoom_thumb_ext {
    height: 93px;
    width: 100%;
    float: left;
}

.zoom_thumb_ext img {
    object-fit: contain;
    margin-bottom: 15px;
}
.priview_icon {
    position: absolute;
    left: 186px;
    cursor: pointer;
}
.right_icon {
    position: absolute;
    right: 0px;
    cursor: pointer;
}
.zoom_thumb_ext video {
    object-fit: cover !important;
    width: 103px !important;
    border: 2px solid #cecece;
}
.vimeo-thumb,
.embed-video-thumb {
    width: 103px !important;
    height: auto;
    border: 2px solid #cecece;
    cursor: pointer;
    position: relative;
    overflow: hidden;
}
.vimeo-thumb img,
.embed-video-thumb img {
    width: 100%;
    height: 100%;
    object-fit: cover;
    display: block;
}
.fav_cart .favorite_button:hover {
    background-color: unset !important;
}
.zoom_thumb_ext img,
video {
    margin-bottom: 30px !important;
    cursor: pointer;
}
.zoom_thumb_ext video {
    margin-bottom: 23px !important;
}
.fav_cart.favriout img {
    width: 100% !important;
}
.zoom_thumb_ext img.zoomer-control.responsive-image.arrow_icon_lft._rgt {
    height: auto !important;
}

.thumb-list .zoomer-control.responsive-image.arrow_icon_lft._rgt {
    height: auto !important;
}
.zoom_img video {
    height: auto !important;
    margin-bottom: 0px !important;
}
.zoom_img video {
    background-color: #ddd;
    padding: 3px;
}
.thumb-img_wdt_hgt {
    height: 600px;
    overflow-y: auto;
    overflow-x: hidden;
    width: 21%;
}
.thumb-list {
    height: auto !important;
}

@media only screen and (max-width: 1600px) {
    .thumb-img_wdt_hgt {
        width: 23%;
    }
}
@media only screen and (max-width: 1440px) {
    .priview_icon {
        left: 184px;
    }
    .thumb-img_wdt_hgt {
        width: 30%;
    }
}
@media only screen and (max-width: 1280px) {
    .zoom_thumb_ext {
        max-width: 80%;
    }
    .zoom_img {
        margin-left: 24px;
    }
    .priview_icon {
        left: 155px;
    }
}
@media only screen and (max-width: 1024px) {
    .zoom_img {
        margin-left: 10px;
    }
    .priview_icon {
        left: 151px;
    }
    .thumb-img_wdt_hgt {
        width: 45%;
    }
}
@media (max-width: 1500px) {
    .zoom_img {
        margin-left: 30px;
    }
}
@media only screen and (max-width: 991px) {
    .preview-box {
        width: 50% !important;
    }
    .thumb-img_wdt_hgt {
        width: 16% !important;
    }
    .priview_icon {
        left: 152px;
    }
}
@media only screen and (max-width: 810px) {
    .thumb-img_wdt_hgt {
        display: none;
    }
    .priview_icon {
        left: 0px;
    }
    .zoom_img {
        margin-left: 0px !important;
    }
}

@media only screen and (max-width: 767px) {
    .thumb-img_wdt_hgt {
        display: none;
    }
    .priview_icon {
        top: 45%;
    }
    .zoom_img {
        height: auto !important;
    }
    .right_icon {
        top: 45%;
    }
}
@media only screen and (max-width: 580px) {
    .preview-box {
        width: 100% !important;
    }
}

/* k_k */
.product_details_update .zoom_img .preview-box.remove_aspect_ratio_imp {
    aspect-ratio: unset;
    max-width: 100%;
    max-height: 100%;
    object-fit: contain;
    width: auto;
    height: auto;
}
</style>
